import React, {useState, useEffect} from 'react'

import {
    Box,
    Stack,
    HStack,
    Modal,
    ModalBody,
    ModalHeader,
    ModalOverlay,
    ModalContent,
    ModalCloseButton
} from '@salesforce/retail-react-app/app/components/shared/ui'

import SelectedStore from './partials/selected-store'
import Header from './partials/header'
import Footer from './partials/footer'
import Search from './partials/search'
import Stores from './partials/stores'
import StoreDetails from './partials/store-details'
import {useStoreContext} from '../../contexts/store'

const SelectStoreModal = () => {
    const {isOpen, onClose, store} = useStoreContext()
    const [storeDetails, setStoreDetails] = useState(null)
    const [stores, setStores] = useState(null)
    const [editStore, setEditStore] = useState(true)
    const [hideNoSearchResults, setHideNoSearchResults] = useState(false)
    const scrollBarStyles = {
        overflowX: 'hidden',
        overflowY: 'auto',
        userSelect: 'none',
        scrollBehavior: 'smooth',
        sx: {
            '&::-webkit-scrollbar': {
                width: '2px'
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'gray.800',
                borderRadius: '2px',
                display: 'block'
            },
            '&::-webkit-scrollbar-track': {
                backgroundColor: 'gray.400',
                borderRadius: '2px',
                display: 'block'
            }
        }
    }

    const handleClose = () => {
        setEditStore(false)
        setStoreDetails(null)
        onClose()
    }

    useEffect(() => {
        if (store && store?.ID) {
            setEditStore(false)
        }
    }, [store])

    useEffect(() => {
        let localStorageStores = localStorage.getItem('savedSearchedStores')
        if (!localStorageStores) return
        try {
            localStorageStores = JSON.parse(localStorageStores)
            setStores(localStorageStores)
        } catch (e) {
            console.log(e.message)
        }
    }, [])

    if (!isOpen) {
        return null
    }

    return (
        <Modal isOpen={isOpen} onClose={handleClose}>
            <ModalOverlay />

            <ModalContent
                borderRadius="0"
                padding="0"
                overflow="hidden"
                marginLeft="auto"
                minHeight={{base: '100vh', lg: 'auto'}}
                maxWidth={{base: '100%', lg: storeDetails ? '1049px' : '411px'}}
                maxHeight={{base: '100vh', lg: '616px'}}
                marginTop={{base: 'auto', lg: '56px'}}
                marginBottom={{base: 0, lg: 'auto'}}
                marginRight={{base: 'auto', lg: '20px', xl: '200px'}}
                transition="max-width 0.2s ease-in-out"
            >
                <HStack
                    gap="0"
                    alignItems="stretch"
                    position={{base: 'relative', lg: 'static'}}
                    maxHeight={{base: '100vh', lg: '616px'}}
                    minHeight="0"
                >
                    {storeDetails && (
                        <Box
                            flex="1"
                            zIndex="3"
                            background="white"
                            width={{base: '100vw', lg: 'auto'}}
                            marginRight={{base: '0', lg: '20px'}}
                            maxHeight={{base: '100vh', lg: '616px'}}
                            minHeight="0"
                            position={{base: 'absolute', lg: 'static'}}
                            {...scrollBarStyles}
                        >
                            <StoreDetails
                                storeDetails={storeDetails}
                                setStoreDetails={setStoreDetails}
                            />
                        </Box>
                    )}

                    <Box
                        width={{base: '100%', lg: '411px'}}
                        display="flex"
                        flexDirection="column"
                        minHeight="0"
                        maxHeight={{base: '100vh', lg: '616px'}}
                        overflow="hidden"
                    >
                        <Box paddingX="20px" paddingTop="20px" flexShrink={0}>
                            <ModalHeader padding="0">
                                <Header editStore={editStore} />
                                <ModalCloseButton
                                    color="black"
                                    top={{base: '20px', lg: '22px'}}
                                    right={{base: '20px', lg: '23px'}}
                                />
                            </ModalHeader>
                        </Box>

                        <ModalBody
                            pt="23px"
                            px="0"
                            pb="0"
                            display="flex"
                            flexDirection="column"
                            flex="1"
                            minHeight="0"
                            overflow="visible"
                        >
                            {store && !editStore ? (
                                <Box paddingX="20px" paddingBottom="20px">
                                    <SelectedStore
                                        setStoreDetails={setStoreDetails}
                                        setHideNoSearchResults={setHideNoSearchResults}
                                        setEditStore={setEditStore}
                                        handleClose={handleClose}
                                    />
                                </Box>
                            ) : (
                                <>
                                    <Box paddingX="20px" flexShrink={0}>
                                        <Search
                                            setStores={setStores}
                                            setHideNoSearchResults={setHideNoSearchResults}
                                        />
                                    </Box>

                                    <Stack
                                        gap="20px"
                                        flex="1"
                                        minHeight="0"
                                        maxHeight={{
                                            base: 'calc(100vh - 240px)',
                                            lg: '420px'
                                        }}
                                        marginTop="15px"
                                        paddingBottom="20px"
                                        {...scrollBarStyles}
                                    >
                                        <Stores
                                            stores={stores}
                                            setStores={setStores}
                                            hideNoSearchResults={hideNoSearchResults}
                                            setStoreDetails={setStoreDetails}
                                            setEditStore={setEditStore}
                                        />

                                        <Box paddingX="20px">
                                            <Footer hideNoSearchResults={hideNoSearchResults} />
                                        </Box>
                                    </Stack>
                                </>
                            )}
                        </ModalBody>
                    </Box>
                </HStack>
            </ModalContent>
        </Modal>
    )
}

export default SelectStoreModal
